import { FC } from 'react';

import { logChatPromiseExecution } from 'stream-chat';
import {
  Window,
  MessageList,
  MessageInput,
  Thread,
  useChannelActionContext,
} from 'stream-chat-react';

import CustomInput from '../CustomInput';

import ChannelHeader from '../ChannelHeader';

export type Props = {};

export const ChannelInner: FC<Props> = () => {
  const { sendMessage } = useChannelActionContext();

  const overrideSubmitHandler = (message: any) => {
    let updatedMessage;

    if (sendMessage) {
      const newMessage = updatedMessage || message;
      const parentMessage = newMessage.parent;

      const messageToSend = {
        ...newMessage,
        parent: parentMessage
          ? {
              ...parentMessage,
              created_at: parentMessage.created_at?.toString(),
              pinned_at: parentMessage.pinned_at?.toString(),
              updated_at: parentMessage.updated_at?.toString(),
            }
          : undefined,
      };

      const sendMessagePromise = sendMessage(messageToSend);
      logChatPromiseExecution(sendMessagePromise, 'send message');
    }
  };

  return (
    <>
      <Window hideOnThread>
        <ChannelHeader />
        <MessageList />
        <MessageInput overrideSubmitHandler={overrideSubmitHandler} />
      </Window>
      <Thread fullWidth Input={CustomInput} />
    </>
  );
};
